import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button"]

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
    this.closeOnEscape = this.closeOnEscape.bind(this)
    this.close = this.close.bind(this)
    document.addEventListener("dropdown:close", this.close)
    document.addEventListener("keydown", this.closeOnEscape)
    this.setExpanded(false)
  }

  toggle(event) {
    event.stopPropagation()
    const opening = this.menuTarget.classList.contains("hidden")
    document.dispatchEvent(new Event("dropdown:close"))
    if (opening) {
      this.menuTarget.classList.remove("hidden")
      this.setExpanded(true)
      document.addEventListener("click", this.closeOnClickOutside)
    }
  }

  close() {
    const wasOpen = !this.menuTarget.classList.contains("hidden")
    this.menuTarget.classList.add("hidden")
    this.setExpanded(false)
    document.removeEventListener("click", this.closeOnClickOutside)
    if (wasOpen && this.hasButtonTarget && this.element.contains(document.activeElement)) {
      this.buttonTarget.focus()
    }
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key !== "Escape") return
    if (this.menuTarget.classList.contains("hidden")) return
    this.close()
  }

  setExpanded(open) {
    if (this.hasButtonTarget) this.buttonTarget.setAttribute("aria-expanded", open ? "true" : "false")
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside)
    document.removeEventListener("dropdown:close", this.close)
    document.removeEventListener("keydown", this.closeOnEscape)
  }
}
